module.exports = __webpack_public_path__ + "static/img/verifydoc.5c6a998.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/verifydoc.png
// module id = IiSn
// module chunks = 7